import { DotCode } from './models/dotcode.model';
import { AngularDotcodesService } from './angular-dotcodes.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fdot-angular-dotcodes',
  template: `
    <span *ngIf="code">
    {{code.description}}
    </span>
  `,
  styles: []
})
export class AngularDotcodesComponent implements OnInit {

  code: DotCode;

  @Input()
  column: string;
  @Input()
  value: string;


  constructor(private dotcodeService: AngularDotcodesService) { }

  ngOnInit() {
    console.log('init');
    this.dotcodeService.GetCode(this.column, this.value).subscribe(code => {
      console.log(code);
      this.code = code;
    });
  }

}
